import * as React from "react";
const SvgRemoveOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M19 13H5v-2h14v2z" />
  </svg>
);
export default SvgRemoveOutlined;
